(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.header.classList.add(
        this.classList.contains('header-transparent')
          ? 'shopify-section-header-always-fixed'
          : 'shopify-section-header-always-sticky'
      );

      this.announcementBar = document
        .querySelector('.shopify-section-announcement-bar .announcement-bar')
        ?.closest('.shopify-section-announcement-bar');

      if (this.announcementBar) {
        this.announcementBar.classList.add('shopify-section-announcement-bar-sticky');
        this.header.classList.add('shopify-section-header-with-announcement');
      }

      this.keepVisible();
    }

    disconnectedCallback() {
      this.announcementBar?.classList.remove('shopify-section-announcement-bar-sticky');
      this.header?.classList.remove('shopify-section-header-with-announcement');
      super.disconnectedCallback();
    }

    hide() {
      this.keepVisible();
    }

    reveal() {
      this.keepVisible();
    }

    reset() {
      this.keepVisible();
    }

    keepVisible() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.body.classList.remove('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-always-sticky') ||
        this.header.classList.contains('shopify-section-header-always-fixed');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
